import _ from 'lodash'

// Find-as-you-type abstraction for live search:
// Ensures in-order delivery of search request results, even
// if the network responses arrive out of order.
//
// replaces multiSearch and lib/api/search.
// this isn't really even search-specific, all it's doing is taking
// some kind of async function that returns a promise and tossing
// out any results that would be delivered in a sequence that is different
// from the synchronous call order of the function

const defaults = {
  throttle: 200
}

export const findAsYouType = (opts) => {
  const {searchFn, throttle, onResults} = Object.assign({}, defaults, opts)
  let searchSequence = 0
  let completedSearchSequence = 0

  const getSearchSequence = () => {
    searchSequence += 1
    return searchSequence
  }

  const search = (...args) => {
    const reqSequence = getSearchSequence()
    searchFn(...args)
      .then(res => {
        // don't overwrite slow search responses with a newer search response
        if (completedSearchSequence < reqSequence) {
          onResults(res)
          completedSearchSequence = reqSequence
        }
      })
  }

  return (throttle > 0)
    ? _.throttle(search, throttle, {leading: true, trailing: true})
    : search
}
